export default __webpack_public_path__ + "static/media/footer-hypercube.5ffe255d.mp4";